<script setup lang="ts">
import { markRaw, ref } from 'vue';
import { PiButton, PiInputField, PiInputLabel, PiIconSolidAngleLeft } from '@pappers-fr/pappers-ui';
import { useSettingsStore } from '@/stores/settings';
import { useConvention } from '@/composables/useConvention';
import { useWordDocument } from '@/composables/useWordDocument';
import { useAuth } from '@/composables/useAuth';
import { useFoldersStore } from '@/stores/folders';

const emit = defineEmits<{ close: [] }>();

const settingsStore = useSettingsStore();
const { preview } = useConvention();
const { renumber } = useWordDocument();
const { logout } = useAuth();
const foldersStore = useFoldersStore();

const localConvention = ref(settingsStore.convention);

const previewText = ref(preview(localConvention.value));

const updatePreview = () => {
	previewText.value = preview(localConvention.value);
};

const save = async () => {
	settingsStore.setConvention(localConvention.value);
	// Renuméroter pour appliquer la nouvelle convention
	await renumber();
	emit('close');
};

const doLogout = async () => {
	logout();
	foldersStore.clearSelection();
};
</script>

<template>
	<div class="flex flex-col h-full">
		<!-- Header -->
		<div class="flex items-center gap-2 p-3 border-b border-neutral-100">
			<PiButton type="ghost" color="muted" size="sm" :icon="markRaw(PiIconSolidAngleLeft)" @click="$emit('close')" />
			<h2 class="text-sm font-semibold text-neutral-800">Paramètres</h2>
		</div>

		<div class="p-4 flex flex-col gap-4">
			<!-- Convention de nommage -->
			<div>
				<PiInputLabel label="Convention de nommage" size="sm" />
				<PiInputField
					:model-value="localConvention"
					size="sm"
					@update:model-value="
						localConvention = $event;
						updatePreview();
					"
				/>
				<p class="text-xs text-neutral-500 mt-1">Variables : {numero}, {nom}, {date}</p>
			</div>

			<!-- Aperçu -->
			<div>
				<PiInputLabel label="Aperçu" size="sm" />
				<div class="px-3 py-2 bg-neutral-50 rounded text-sm text-neutral-700 border border-neutral-100">
					{{ previewText }}
				</div>
			</div>

			<!-- Sauvegarder -->
			<PiButton label="Enregistrer" color="primary" size="sm" is-full-width @click="save" />

			<!-- Déconnexion -->
			<PiButton label="Déconnexion" color="red" type="ghost" size="sm" is-full-width @click="doLogout" />

			<p class="text-[11px] text-neutral-400 mt-4 text-center">
				Certains éléments sont générés par une IA (rappel des faits, nom des pièces, etc.). L'IA peut faire des erreurs,
				vérifiez les informations fournies.
			</p>
		</div>
	</div>
</template>
